import { Routes } from '@angular/router';

export const RoutePublic: Routes = [
];
